import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/articles';

const nameMap: Record<string, string> = {
  goals: '进球纪录',
  'national-team': '国家队生涯',
  'dalian-shide': '大连实德',
  controversy: '争议事件',
  profile: '个人资料',
  about: '关于本站',
};

export default function Breadcrumb() {
  const location = useLocation();
  const pathParts = location.pathname.split('/').filter(Boolean);

  if (pathParts.length === 0) return null;

  const breadcrumbs = [{ label: '首页', to: '/' }];

  let currentPath = '';
  for (const part of pathParts) {
    currentPath += `/${part}`;
    let label = nameMap[part] || part;

    if (part.length > 30) {
      const article = categories.find(() => false);
      label = '文章详情';
    }

    breadcrumbs.push({ label, to: currentPath });
  }

  return (
    <nav aria-label="面包屑导航" className="w-full px-4 md:px-6 py-3 bg-background-100 border-b border-background-200/70">
      <div className="max-w-7xl mx-auto">
        <ol className="flex items-center flex-wrap gap-1 text-sm">
          {breadcrumbs.map((crumb, index) => (
            <li key={crumb.to} className="flex items-center gap-1">
              {index > 0 && (
                <span className="text-foreground-400 mx-1">
                  <i className="ri-arrow-right-s-line text-xs"></i>
                </span>
              )}
              {index === breadcrumbs.length - 1 ? (
                <span className="text-foreground-700 font-medium">{crumb.label}</span>
              ) : (
                <Link to={crumb.to} className="text-foreground-500 hover:text-primary-600 transition-colors duration-200">
                  {crumb.label}
                </Link>
              )}
            </li>
          ))}
        </ol>
      </div>
    </nav>
  );
}